// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccountView_container__Erwri {
  width: 30%;
  padding: 30px;
  margin-left: 15%;
  text-align: left;
}

h1 {
  font-weight: bold;
  text-align: center;
  color: rgba(29, 135, 82, 1);
  font-size: 32px;
  margin-bottom: 30px;
}

.AccountView_card__aV7Va {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
  padding: 30px;
  transition: transform 0.2s;
}

.AccountView_card__aV7Va:hover {
  transform: translateY(-5px);
}

.AccountView_header__nUJrE {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
}

.AccountView_avatar__oHgS\\+ {
  width: 70px;
  height: 70px;
  background-color: rgba(29, 135, 82, 0.2);
  color: rgba(29, 135, 82, 1);
  font-size: 28px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.AccountView_userInfo__bKs2Z h2 {
  margin: 0;
  font-size: 24px;
}

.AccountView_role__WCvzk {
  display: inline-block;
  background-color: rgba(29, 135, 82, 0.1);
  color: rgba(29, 135, 82, 1);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
  margin-top: 4px;
}

.AccountView_section__hqftE {
  margin-bottom: 25px;
}

.AccountView_section__hqftE h3 {
  color: rgba(29, 135, 82, 1);
  margin-bottom: 12px;
  font-size: 18px;
}

.AccountView_row__ZXex4 {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
  font-size: 16px;
}

.AccountView_active__tjzYl {
  color: rgba(29, 135, 82, 1);
  font-weight: bold;
}

.AccountView_inactive__oiFT0 {
  color: #999;
  font-weight: bold;
}

.AccountView_loading__1cf2P {
  text-align: center;
  font-size: 18px;
  color: rgba(29, 135, 82, 1);
}
`, "",{"version":3,"sources":["webpack://./src/styles/AccountView.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B","sourcesContent":[".container {\n  width: 30%;\n  padding: 30px;\n  margin-left: 15%;\n  text-align: left;\n}\n\nh1 {\n  font-weight: bold;\n  text-align: center;\n  color: rgba(29, 135, 82, 1);\n  font-size: 32px;\n  margin-bottom: 30px;\n}\n\n.card {\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.1);\n  padding: 30px;\n  transition: transform 0.2s;\n}\n\n.card:hover {\n  transform: translateY(-5px);\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.avatar {\n  width: 70px;\n  height: 70px;\n  background-color: rgba(29, 135, 82, 0.2);\n  color: rgba(29, 135, 82, 1);\n  font-size: 28px;\n  font-weight: bold;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.userInfo h2 {\n  margin: 0;\n  font-size: 24px;\n}\n\n.role {\n  display: inline-block;\n  background-color: rgba(29, 135, 82, 0.1);\n  color: rgba(29, 135, 82, 1);\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n  margin-top: 4px;\n}\n\n.section {\n  margin-bottom: 25px;\n}\n\n.section h3 {\n  color: rgba(29, 135, 82, 1);\n  margin-bottom: 12px;\n  font-size: 18px;\n}\n\n.row {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px solid #eee;\n  font-size: 16px;\n}\n\n.active {\n  color: rgba(29, 135, 82, 1);\n  font-weight: bold;\n}\n\n.inactive {\n  color: #999;\n  font-weight: bold;\n}\n\n.loading {\n  text-align: center;\n  font-size: 18px;\n  color: rgba(29, 135, 82, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AccountView_container__Erwri`,
	"card": `AccountView_card__aV7Va`,
	"header": `AccountView_header__nUJrE`,
	"avatar": `AccountView_avatar__oHgS+`,
	"userInfo": `AccountView_userInfo__bKs2Z`,
	"role": `AccountView_role__WCvzk`,
	"section": `AccountView_section__hqftE`,
	"row": `AccountView_row__ZXex4`,
	"active": `AccountView_active__tjzYl`,
	"inactive": `AccountView_inactive__oiFT0`,
	"loading": `AccountView_loading__1cf2P`
};
export default ___CSS_LOADER_EXPORT___;
